import React, {Component} from 'react'
import PropTypes from 'prop-types'
import './style.css'
import ContentContainer from '../../_common/_containers/ContentContainer/index'
import NRTButton from "../../_common/_buttons/Button"
import Logo from "../Logo"
import PoweredBy from "../PoweredBy"
import MCProfileMenu from '../../_common/ProfileMenu'

class NavBar extends Component {


    goToPage = (page) => {
        if (page === 'logout') {
            this.props.history.push('/')
            return this.props.context.logout()
        }


        if (page === 'profile')
            return this.props.history.push('/conta/perfil')

        this.props.history.push('/conta')
    }


    render() {

        const props = this.props
        const {
            //    hideButtons,
            context,
            logoImgSrc,
            title,
        } = props

        return (
            <div className={'nav-bar-wrapper'}>
                <ContentContainer className={'nav-bar-container content-wrapper'}>
                    <div className="logo-container">
                        <div className="img-wrapper">
                            <Logo imgSrc={logoImgSrc}
                                  title={title}
                                  style={{maxHeight: '3.5rem'}}
                            />
                        </div>

                    </div>

                    <div className="poweredby-container">
                        <img src={require('./arrow.png')}/>
                        <PoweredBy style={{}}/>
                    </div>


                    <span style={{flex: 1}} className="spacer"/>

                    {
                        !context.person &&
                        (
                            <div className="buttons-container">
                                <NRTButton
                                    onClick={() => {
                                        // window.location = `http://${schema}.minhacentral.com.br/minhacentral/login.jsf`
                                        props.history.push("/login/home")
                                    }}
                                    secondary>

                                    <img src={require('./../../../assets/images/logocentral.png')}
                                         style={{
                                             height: '1.2rem',
                                             marginRight: '.3rem'
                                         }}/>
                                    Acessar Meus Cursos
                                </NRTButton>

                            </div>
                        )}

                    {
                        context.person && (
                            <div className="buttons-container">


                                <div className="btn-my-courses">
                                    <NRTButton
                                        onClick={() => {
                                            this.goToPage('account')
                                        }}
                                        secondary>

                                        <img src={require('./../../../assets/images/logocentral.png')}
                                             style={{
                                                 height: '1.2rem',
                                                 marginRight: '.3rem'
                                             }}/>
                                        Meus cursos
                                    </NRTButton>

                                </div>


                                <div className="avatar">
                                    <MCProfileMenu style={{borderLeft: 0, paddingRight: 0}}
                                                   avatarProfile={context.person.mainImageUrl}
                                                   nameProfile={context.person.name}
                                                   onRouteClick={this.goToPage}
                                                   showAccountLink
                                    />

                                </div>


                            </div>
                        )
                    }
                </ContentContainer>
            </div>
        )
    }
}

NavBar.propTypes = {
    history: PropTypes.object,
    loggedIn: PropTypes.bool,
    logoImgSrc: PropTypes.string,
    hideButtons: PropTypes.bool,
    title: PropTypes.string
}

NavBar.defaultProps = {
    loggedIn: false,
    hideButtons: false
}

export default NavBar



// WEBPACK FOOTER //
// ./src/components/_minha-central/NavBar/index.js